/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class MainArticle extends HTMLElement {
  constructor() {
    super();

    const { twscEnabled, remURL } = contextualise('article');

    if (!twscEnabled) {
      return;
    }

    this.api = new API(remURL);

    this.init();
  }

  toggleQuizBlock() {
    this.api.profile()
      .then((profile) => {
        quizBlock.hidden = profile.has_quiz;
        return profile;
      })
      .catch((err) => {
        Bugsnag.notify(err);
      });
  }

  init() {
    // on init
  }
}

if (!customElements.get('main-article')) {
  customElements.define("main-article", MainArticle);
}
